import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const ADMIN_CONTENT_SELECTOR = ".admin-layout__content"

const scrollToTop = () => {
  window.scrollTo(0, 0)

  document.querySelectorAll(ADMIN_CONTENT_SELECTOR).forEach(container => {
    container.scrollTop = 0
  })
}

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual"
}

/**
 * Resets scroll position on route changes. Member layouts scroll on window;
 * admin layouts scroll inside .admin-layout__content.
 */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    scrollToTop()
  }, [pathname, search, hash])

  return null
}

export default ScrollToTop
